import { Box, Typography, Tooltip, Avatar } from '@mui/material'
import { RosterSlotCard as StyledRosterSlotCard } from './styledComponents'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'

const ROSTERING_MODE_ON_CALL = 'on-call'

const getRosteringModeLabel = (slot) => {
  if (slot?.rosteringMode === ROSTERING_MODE_ON_CALL) {
    return 'On-call'
  }
  if (slot?.presenceRequired === true) {
    return 'Check-in'
  }
  return ''
}

export default function RosterSlotCard({ slot, onClick, color, textColor, isUnoccupied = false }) {
  const rosteringModeLabel = getRosteringModeLabel(slot)

  if (isUnoccupied) {
    return (
      <Tooltip title={`Click to assign slot: ${slot.slotStartTime} - ${slot.slotEndTime}`}>
        <StyledRosterSlotCard
          isUnoccupied={true}
          onClick={onClick}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '50px',
          }}
        >
          <Typography variant="caption" sx={{ fontSize: '0.7rem', fontWeight: 600 }}>
            + Add Slot
          </Typography>
          <Typography variant="caption" sx={{ fontSize: '0.65rem' }}>
            {slot.slotStartTime} - {slot.slotEndTime}
          </Typography>
          {rosteringModeLabel && (
            <Typography variant="caption" sx={{ fontSize: '0.6rem', opacity: 0.8 }}>
              {rosteringModeLabel}
            </Typography>
          )}
        </StyledRosterSlotCard>
      </Tooltip>
    )
  }

  return (
    <Tooltip
      title={`${slot.mentorName || slot.mentorTitle || 'Practitioner'} - ${slot.slotStartTime} to ${slot.slotEndTime}${rosteringModeLabel ? ` (${rosteringModeLabel})` : ''}`}
    >
      <StyledRosterSlotCard
        color={color}
        onClick={onClick}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          ...(textColor && { color: textColor }),
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          {slot.mentorProfilePicId && (
            <Avatar
              src={getImageLink(slot.mentorProfilePicId)}
              sx={{ width: 20, height: 20, fontSize: '0.65rem', flexShrink: 0 }}
            >
              {(slot.mentorName || slot.mentorTitle)?.[0]?.toUpperCase()}
            </Avatar>
          )}
          <Typography
            variant="caption"
            sx={{
              fontSize: '0.75rem',
              fontWeight: 600,
              lineHeight: 1.2,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flex: 1,
            }}
          >
            {slot.mentorName || slot.mentorTitle || 'Unassigned'}
          </Typography>
        </Box>
        <Typography variant="caption" sx={{ fontSize: '0.65rem', opacity: 0.9 }}>
          {slot.slotStartTime} - {slot.slotEndTime}
        </Typography>
        {rosteringModeLabel && (
          <Typography variant="caption" sx={{ fontSize: '0.6rem', opacity: 0.85, fontWeight: 700 }}>
            {rosteringModeLabel}
          </Typography>
        )}
        {slot.bookedSlotsCount > 0 && (
          <Box
            sx={{
              fontSize: '0.6rem',
              backgroundColor: 'rgba(0,0,0,0.2)',
              borderRadius: 1,
              px: 0.5,
              mt: 0.25,
              display: 'inline-block',
            }}
          >
            {slot.bookedSlotsCount} booked
          </Box>
        )}
      </StyledRosterSlotCard>
    </Tooltip>
  )
}
